'use strict';

angular.module('atex.dam').controller('DamPublishingScheduleDefaultModalController', ['$scope', '$rootScope', '$q', 'DamSchedulingService','ContentService', 'DamTemplateService', 'DamService', 'configuration','DamConfigurationService', '$translate', 'DamStatusService', 'DamMarkAsService','DamNotificationService', 'UIConfigurationService', 'DamAuthorService',
  function($scope, $rootScope, $q, DamSchedulingService, ContentService, DamTemplateService, DamService, configuration, DamConfigurationService, $translate, DamStatusService, DamMarkAsService, DamNotificationService, UIConfigurationService, DamAuthorService) {

    $scope.panelTitle = $translate.getTranslationTable().__PUBLISHING_SCHEDULE_MAINTAIN_DEFAULTS_FOR__ + getTemplate($scope.model.templateId).label;

    $translate(['__GENERIC_ERROR_MSG__', '__OPERATION_COMPLETED_SUCCESSFULLY__']).then(function (translations) {
      $scope.message = {};
      $scope.message.error = translations.__GENERIC_ERROR_MSG__;
      $scope.message.success = translations.__OPERATION_COMPLETED_SUCCESSFULLY__;
    });

    $scope.loaded = false;
    $scope.showSpinner = true;
    $scope.article = atex.Content();
    $scope.local = {"existsOnServer" : false};
    $scope.isValid = false;

    DamService.getCurrentDamUserInfo().then(function (currentUserInfo) {
      $scope.currentUserInfo = currentUserInfo;

      DamTemplateService.loadCreateContentTemplates().then(function () {
        DamTemplateService.getTemplateById($scope.templateId).then(function (template) {
          template = getTemplate($scope.model.templateId);
          $scope.template = angular.copy(template);
          $scope.article.template = $scope.template;

          if ($scope.model.isNew) {
            atex.onecms.ObjectUtils.accessor($scope.article.data, 'aspects/atex.OneCMS/data/createdWithTemplate').value = $scope.template.id;
            updateAspects();
            $scope.loaded = true;
          } else {
            DamSchedulingService.getSchedulingContent($scope.model.id).then(function (response) {
              $scope.article = angular.copy(response);
              $scope.local.existsOnServer = true;
              $scope.loaded = true;
          }).then(null, function (error) {
            $scope.showSpinner = false;
            var message = $scope.message.error + " (" + error.cause + ")";
            DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
          });
          }
        }).then(null, function (error) {
          $scope.showSpinner = false;
          var message = $scope.message.error + " (" + error.cause + ")";
          DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
        });
      }).then(null, function (error) {
        $scope.showSpinner = false;
        var message = $scope.message.error + " (" + error.cause + ")";
        DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
      });
    });

    $scope.hideSpinner = function () {
      $scope.showSpinner = false;
    };

    function submit(cleanData) {
      if ($scope.model.isNew) {
        DamSchedulingService.createContent(cleanData).then(function (result) {
          DamSchedulingService.getSchedulingContent(result.id).then(function (content) {
            $scope.showSpinner = false;
            $scope.$parent.doOk(content);
          });
        }).then(null, function (error) {
          $scope.showSpinner = false;
          var message = $scope.message.error + " (" + error.cause + ")";
          DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
        });
      } else {
        var updateInfo = {id: $scope.article.id, data: cleanData, revision: $scope.article.revision};
        DamSchedulingService.updateContent(updateInfo).then(function (response) {
          DamSchedulingService.getSchedulingContent(response.id).then(function (content) {
            $scope.showSpinner = false;
            $scope.$parent.doOk(content);
          });
        }).then(null, function (error) {
          $scope.showSpinner = false;
          var message = $scope.message.error + " (" + error.cause + ")";
          DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
        });
      }
    }

    function getTemplate(template) {
      for (var i = 0; i < $scope.model.types.length; i++) {
        var type = $scope.model.types[i];
        if (type.id === template) {
          return type;
        }
      }
    }

    function updateAspects() {
      atex.onecms.ObjectUtils.accessor($scope.article, "data/aspects/p.InsertionInfo/data").value = $scope.model.parentContent.data.aspects["p.InsertionInfo"].data;
      atex.onecms.ObjectUtils.accessor($scope.article, "data/aspects/atex.Metadata").value =  $scope.model.parentContent.data.aspects["atex.Metadata"];
    }

    $scope.doSave = function () {
      $scope.showSpinner = true;
      //change the object type so that the results do not appear in desk search only in the scheduling panel
      atex.onecms.ObjectUtils.accessor($scope.article, "data/aspects/contentData/data/objectType").value = "publishingScheduleDefault";
      var json = angular.toJson($scope.article.data);
      var cleanData = angular.fromJson(json);
      submit(cleanData);
    };

    $scope.changeEndCallback = function (data) {
      $scope.article.data = data;
      $scope.dirty = true;
      if(!$scope.$$phase) {
        $scope.$digest();
      }
      return;
    };

  }]);